module.exports = __webpack_public_path__ + "static/media/mediPangPang_BI_v1.0_197_51@3x.e08e12e1.png";